import React from 'react'
import { useContext } from '../Context'
import { PopUpContainer } from '../PopUpContainer'
import { MenuPopUpEnum } from '../MenuPopUpEnum'
import { AddForm } from '../../../AddPurchaseOrder/AddForm'
import type { NextFunction, PurchaseOrder } from '@ztechapps/common.contract'

export const PurchaseOrderPopUp = () => {
  const { menuTarget, onCloseMenu } = useContext()

  const next: NextFunction<PurchaseOrder> = async (data, error) => {
    if (!error) {
      onCloseMenu()
    }
  }

  return (
    <PopUpContainer show={menuTarget?.show === MenuPopUpEnum.purchase} target={menuTarget?.target}>
      <AddForm next={next} />
    </PopUpContainer>
  )
}
